import React from 'react'

const EmptyComment = (props) => (
  <svg
    width="256"
    height="224"
    viewBox="0 0 256 224"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5495 0H208.176C214.002 0 218.725 4.72982 218.726 10.5647V94.5202H119.844C115.78 94.5202 112.485 97.8244 112.485 101.901V157.062H76.3075L36.5685 196.859C33.455 199.977 28.132 197.768 28.132 193.359V157.062H10.5495C4.723 157.062 0 152.331 0 146.497V10.5647C0 4.72982 4.723 0 10.5495 0Z"
      fill="#4A5068"
    />
    <path
      d="M62.4161 91.2084C69.4075 91.2084 75.0751 85.5325 75.0751 78.5311C75.0751 71.5296 69.4075 65.8538 62.4161 65.8538C55.4247 65.8538 49.7571 71.5296 49.7571 78.5311C49.7571 85.5325 55.4247 91.2084 62.4161 91.2084Z"
      fill="white"
    />
    <path
      d="M108.485 91.2081C115.477 91.2081 121.144 85.5323 121.144 78.5308C121.144 71.5293 115.477 65.8535 108.485 65.8535C101.494 65.8535 95.8265 71.5293 95.8265 78.5308C95.8265 85.5323 101.494 91.2081 108.485 91.2081Z"
      fill="white"
    />
    <path
      d="M154.549 91.2081C161.541 91.2081 167.208 85.5323 167.208 78.5308C167.208 71.5293 161.541 65.8535 154.549 65.8535C147.558 65.8535 141.89 71.5293 141.89 78.5308C141.89 85.5323 147.558 91.2081 154.549 91.2081Z"
      fill="white"
    />
    <path
      d="M128.021 103.584H249.515C253.096 103.584 256 106.456 256 109.999V192.535C256 196.077 253.096 198.95 249.515 198.95H238.705V220.989C238.705 223.666 235.433 225.007 233.519 223.114L209.089 198.95H128.021C124.439 198.95 121.535 196.078 121.535 192.535V109.999C121.536 106.456 124.439 103.584 128.021 103.584Z"
      fill="#A4A9C1"
    />
    <ellipse
      cx="158.854"
      cy="146.136"
      rx="8.87434"
      ry="8.88716"
      fill="#383838"
    />
    <ellipse cx="157.489" cy="144.769" rx="4.77849" ry="4.7854" fill="white" />
    <ellipse cx="161.926" cy="151.263" rx="1.7066" ry="1.70907" fill="white" />
    <ellipse
      cx="213.466"
      cy="146.136"
      rx="8.87434"
      ry="8.88716"
      fill="#383838"
    />
    <ellipse cx="212.1" cy="144.769" rx="4.77849" ry="4.7854" fill="white" />
    <ellipse cx="216.537" cy="151.263" rx="1.7066" ry="1.70907" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M184.331 161.346C179.61 162.024 176.07 164.621 174.285 167.022C173.834 167.628 172.979 167.753 172.374 167.302C171.77 166.851 171.644 165.994 172.095 165.389C174.291 162.435 178.465 159.426 183.944 158.64C189.472 157.846 196.186 159.333 203.399 165.14C203.986 165.613 204.08 166.474 203.607 167.062C203.135 167.651 202.276 167.744 201.688 167.271C194.975 161.866 189.003 160.676 184.331 161.346Z"
      fill="#383838"
    />
  </svg>
)

export default EmptyComment
